
import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { useClaimRequests } from './claim-requests/useClaimRequests';
import PendingClaimsTab from './claim-requests/PendingClaimsTab';
import ProcessedClaimsTab from './claim-requests/ProcessedClaimsTab';

const CompanyClaimRequests = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const { requests, isLoading, handleApprove, handleReject } = useClaimRequests();

  const pendingRequests = requests.filter(req => req.status === 'pending');
  const processedRequests = requests.filter(req => req.status !== 'pending');

  return (
    <div className="space-y-4">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-2 w-full max-w-md mb-4">
          <TabsTrigger value="pending" className="flex items-center gap-2">
            Pending Requests
            {pendingRequests.length > 0 && (
              <Badge className="ml-2 bg-redflags-red text-white">
                {pendingRequests.length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="processed">Processed Requests</TabsTrigger>
        </TabsList>
        
        <TabsContent value="pending">
          <PendingClaimsTab 
            requests={pendingRequests}
            isLoading={isLoading}
            onApprove={handleApprove}
            onReject={handleReject}
          />
        </TabsContent>
        
        <TabsContent value="processed">
          <ProcessedClaimsTab 
            requests={processedRequests}
            isLoading={isLoading}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CompanyClaimRequests;
